// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-components-OauthButtons-styles--normal--tYG4o {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
  width: 100%;
}

@media screen and (min-width: 768px) {

.src-components-OauthButtons-styles--normal--tYG4o {
    margin-top: 25px;
    margin-bottom: 45px;
}
  }

.src-components-OauthButtons-styles--normal--tYG4o .src-components-OauthButtons-styles--button--ctrgy + .src-components-OauthButtons-styles--button--ctrgy {
    margin-left: 8px;
  }

.src-components-OauthButtons-styles--normal--tYG4o .scrollarea .scrollbar-container {
    opacity: 0;
    z-index: 100;
  }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/components/OauthButtons/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AAeb;;AAbE;;AANF;IAOI,gBAAgB;IAChB,mBAAmB;AAWvB;EAVE;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,UAAU;IACV,YAAY;EACd","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.normal {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  text-align: center;\n  width: 100%;\n\n  @media (--desktop) {\n    margin-top: 25px;\n    margin-bottom: 45px;\n  }\n\n  & .button + .button {\n    margin-left: 8px;\n  }\n\n  & :global(.scrollarea .scrollbar-container) {\n    opacity: 0;\n    z-index: 100;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"normal": `src-components-OauthButtons-styles--normal--tYG4o`,
	"button": `src-components-OauthButtons-styles--button--ctrgy`
};
module.exports = ___CSS_LOADER_EXPORT___;
